import Sidebar from '../envelope/Sidebar'
import TopBar from '../envelope/TopBar'
import TestPattern from '../CreatePages/TestPattern';
import TestCard from './TestCard';
import React, { useState } from 'react';
import './CreateLink.css'
import CopyButtonLink from '../media/imagen/CopyButtonLink.svg'
import { useLocation } from 'react-router-dom';
import GroupCard from './GroupCard';
import * as XLSX from 'xlsx';

const CreateLink = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const location = useLocation();
  const creationData = location.state || {}; 
  const {
    testId,
    name = "Название тестирования",
    description = "Описание тестирования",
    selectedGroup = null,
    selectedTestPattern = null
  } = creationData;

  // Получаем пользователей из selectedGroup
  const groupUsers = selectedGroup?.users || [];

  const LinkPers = ({ userName, userId, userMail }) => {
    const link = `${window.location.origin}/testing/${testId}/${userId}`;
    
    const copyToClipboard = () => {
      navigator.clipboard.writeText(link);
      alert('Ссылка скопирована!');
    };

    return (
      <div className='LinkPanel'>
        <div className='LinkName'>{userName}</div>
        <div className='Link'>{link}</div>
        <img 
          src={CopyButtonLink} 
          alt="Копировать ссылку" 
          onClick={copyToClipboard}
          style={{ cursor: 'pointer' }}
        />
      </div>
    );
  };

  // Функция экспорта в Excel
  const exportToExcel = () => {
    if (groupUsers.length === 0) return;
    
    const data = groupUsers.map(user => ({
      'Имя сотрудника': user.user_name,
      'Email': user.user_mail,
      'Ссылка для тестирования': `${window.location.origin}/testing/${testId}/${user.user_id}`
    }));
    
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Ссылки для тестирования');
    
    // Генерируем имя файла на основе названия теста
    const fileName = `Ссылки_${name.replace(/\s+/g, '_')}.xlsx`;
    
    XLSX.writeFile(workbook, fileName);
  };

  // Функция отправки на почту
const sendEmails = async () => {
  if (groupUsers.length === 0) return;
  
  setIsSending(true);
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      console.error('Токен авторизации не найден');
      return;
    }
    
    // Формируем массив сообщений
    const messages = groupUsers.map(user => ({
      mail: user.user_mail,
      message: `Здравствуйте, ${user.user_name}!\n\nПриглашаем вас пройти тестирование "${name}".\n\nСсылка для прохождения: ${window.location.origin}/testing/${testId}/${user.user_id}\n\nС уважением,\nКоманда платформы`
    }));
    
    // Формируем итоговый объект для отправки
    const requestData = {
      messages: messages // Это создаст структуру как на скриншоте
    };
    
    const response = await fetch('http://185.250.149.189:8000/api/v1/SendMails', {
      method: 'POST',
      headers: {
        'Authorization': `Token ${token}`,
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify(requestData) // Отправляем объект с messages
    });

    console.log(requestData); // Проверяем структуру в консоли
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    setShowModal(true);
  } catch (error) {
    console.error('Ошибка при отправке писем:', error);
    alert('Произошла ошибка при отправке писем');
  } finally {
    setIsSending(false);
  }
};

  return (
    <div className="dashboard">
      <Sidebar 
        isCollapsed={isSidebarCollapsed} 
        toggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      <TopBar isCollapsed={isSidebarCollapsed} />  
      <main className={`main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="content-container">
            <div className='ShapkaLink'>
            <h4>Тестирование</h4>
            <h1>{name}</h1>
            <span>{description}</span>
            </div>
            <div className='CardLink'>
            {selectedGroup && <GroupCard group={selectedGroup} disabled={true} />}
            {selectedTestPattern && <TestCard test={selectedTestPattern} disabled={true} />}
            </div>
            <div className='LinkContainer'> 
            <div className='ShapkaLink-container'>
                <h1>Ссылки на тестирование для сотрудников</h1>
                <div className="LinkButtons">
                    <button 
                      className="ExportButton" 
                      onClick={exportToExcel}
                      disabled={groupUsers.length === 0}
                    >
                        Экспорт в Excel
                    </button>
                    <button 
                      className="SendButton" 
                      onClick={sendEmails}
                      disabled={isSending || groupUsers.length === 0}
                    >
                        {isSending ? 'Отправка...' : 'Отправить на почту'}
                    </button>
                </div>
            </div>
            
            <div className='LinkLink'>
              {groupUsers.length > 0 ? (
                groupUsers.map(user => (
                  <LinkPers 
                    key={user.user_id} 
                    userName={user.user_name} 
                    userId={user.user_id} 
                    userMail={user.user_mail}
                  />
                ))
              ) : (
                <div>В группе нет пользователей</div>
              )}
            </div>
            </div>
        </div>
        </main>

        {/* Модальное окно успешной отправки */}
        {showModal && (
          <div className="modal-overlay">
            <div className="success-modal">
              <div className="modal-illustration">
                <div className="paper-plane-animation"></div>
              </div>
              <div className="modal-content">
                <h2>Все ссылки-приглашения были отправлены пользователям.</h2>
                <p>Спасибо за использование нашей платформы!</p>
                <button 
                  className="modal-confirm-button"
                  onClick={() => setShowModal(false)}
                >
                  Хорошо!
                </button>
              </div>
            </div>
          </div>
        )}
    </div>
    );
};

export default CreateLink;